module.exports = __webpack_public_path__ + "static/message-background-sp-78e3b3e23a8ec5bf521400daee158a48.jpg";